import React, { useEffect, useState } from "react";
import { getRequest } from "../../apiWrapper";
import { formatDate } from "../../utils/formatDate";

const periods = [1, 2, 3, 4, 5, 6, 7];

const AdminDailySchedule = () => {
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return formatDate(today); // yyyy-mm-dd
  });

  const [teachers, setTeachers] = useState([]);
  const [students, setStudents] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [scheduleMap, setScheduleMap] = useState({}); // { period: { teacherid: [{studentid, subjectid}, ...] } }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [teacherRes, studentRes, subjectRes, scheduleRes] = await Promise.all([
          getRequest("teachers"),
          getRequest("students"),
          getRequest("subjects"),
          getRequest(`lessonSchedules?start=${selectedDate}&end=${selectedDate}`)
        ]);

        setTeachers(teacherRes.teachers || []);
        setStudents(studentRes.students || []);
        setSubjects(subjectRes.subjects || []);

        const tempMap = {};
        for (let p of periods) tempMap[p] = {};

        (scheduleRes.schedules || []).forEach(item => {
          const { period, teacherid, student1id, subject1id, student2id, subject2id } = item;
          if (!tempMap[period][teacherid]) tempMap[period][teacherid] = [];

          if (student1id) {
            tempMap[period][teacherid].push({ studentid: student1id, subjectid: subject1id });
          }
          if (student2id) {
            tempMap[period][teacherid].push({ studentid: student2id, subjectid: subject2id });
          }
        });

        setScheduleMap(tempMap);
      } catch (err) {
        console.error("スケジュール取得エラー:", err);
      }
    };

    fetchData();
  }, [selectedDate]);

  const getTeacherName = (id) => teachers.find(t => t.id === id)?.name || "(不明)";
  const getStudentName = (id) => students.find(s => s.id === id)?.name || "(不明)";
  const getSubjectName = (id) => subjects.find(s => s.id === id)?.name || "";

  return (
    <div className="p-4 pt-20">
      <h1 className="text-2xl font-bold mb-4">講別スケジュール（管理者用）</h1>

      <div className="mb-6">
        <label className="text-sm mr-2">表示日：</label>
        <input
          type="date"
          className="border rounded px-2 py-1"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />
      </div>

      {periods.map(p => (
        <div key={p} className="mb-6">
          <h2 className="text-lg font-semibold mb-2">{p}講</h2>
          {scheduleMap[p] && Object.keys(scheduleMap[p]).length > 0 ? (
            <ul className="list-disc pl-6 space-y-2 text-sm">
              {Object.entries(scheduleMap[p]).map(([teacherId, studentList]) => (
                <li key={teacherId}>
                  <strong>{getTeacherName(teacherId)}</strong>
                  <ul className="ml-4 list-none text-sm text-gray-700">
                    {studentList.map((s, idx) => (
                      <li key={idx}>
                        {getStudentName(s.studentid)}
                        {s.subjectid && (
                          <div className="text-xs text-gray-500 ml-2">
                            （{getSubjectName(s.subjectid)}）
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-sm text-gray-500">この時間の授業はありません。</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default AdminDailySchedule;
